import loadable from '@loadable/component';

export const ViewInternshipPageLoadable = loadable(
  () => import('./ViewInternshipPage'),
  { resolveComponent: (module) => module.ViewInternshipPage },
);
